import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { updateFilterPriority } from 'store/reducer/filter/slice';
import Select from 'components/ui/Select';
import { PRIORITY_OPTION, EMPTY_STRING } from 'constants/general';
import { t } from 'services/i18n.service';
import { useMemo } from 'react';
import { moreOptionModalPrioritySelector } from 'store/reducer/modal/more-options.modal.selectors';

const FilterPriorityRevamp: React.FC = () => {
  const dispatch = useAppDispatch();
  const { filterPriority } = useAppSelectorShallow(
    moreOptionModalPrioritySelector
  );

  const prioritySelectOptions = useMemo(() => {
    const priorityOptions = [
      { label: t('must_do'), value: PRIORITY_OPTION.HIGH },
      { label: t('optional'), value: PRIORITY_OPTION.STANDARD }
    ];
    const clearOption = {
      value: '',
      label: t('settings_page.all')
    };
    if (filterPriority) {
      return [clearOption, ...priorityOptions];
    }
    return priorityOptions;
  }, [filterPriority]);

  const handleChange = (value: string) => {
    dispatch(updateFilterPriority(value || EMPTY_STRING));
  };

  return (
    <Select
      options={prioritySelectOptions}
      value={filterPriority || ''}
      onChange={handleChange}
      placeholder={t('settings_page.select_priority')}
      size='sm'
      isFullWidth={true}
      className='min-w-[250px]'
    />
  );
};

export default FilterPriorityRevamp;
